/**
 * Landing scripts
 *
 * @copyright 2018 Linguistica 360
 */

import '../libs/jquery.smooth-scroll.js';
import 'slick-carousel';

import $ from 'jquery';
import iziToast from 'izitoast';
import throttle from 'lodash/throttle.js';

import { Script, injector } from '../shared/injector.js';
import { $wrap, hasGroup, resolveRoot } from '../shared/utils.js';


injector.injectClass(class extends Script {
    onLoad() {
        this.showFooter();

        $('.tile-wrapper').slick({
            rows: 0,
            infinite: true,
            dots: false,
            speed: 300,
            variableWidth: true,
            slidesToScroll: 3,
            swipeToSlide: true,
            nextArrow: $('.tile-arrows .netflix-arrow.right'),
            prevArrow: $('.tile-arrows .netflix-arrow.left'),
            responsive: [{
                breakpoint: 1024, settings: { slidesToScroll: 2 },
            }, {
                breakpoint: 600, settings: { slidesToScroll: 1 },
            }],
        });


        const selAdd = 'a[data-action=playlist-add]';
        $('body').on('click', selAdd, this.wrap(this.playlistAdd));

        const selEdit = 'a[data-action=playlist-edit]';
        $('body').on('click', selEdit, this.$wrap(this.playlistEdit));

        const selDelete = 'a[data-action=playlist-delete]';
        $('body').on('click', selDelete, this.$wrap(this.playlistDelete));
        this.initGex();
        this.initScroll();
    }

    showFooter() {
        this.$appItemContainer = $('#appIconContainer');
        this.$appItemContainer.css('display', 'block');

        this.$footerContainer = $('#footerContainer');
        this.$footerContainer.css('display', 'block');
    }

    playlistAdd() {
        const name = prompt('Playlist name');
        if (!name) return;

        $.ajax({
            url: resolveRoot('ajax/playlist'),
            method: 'POST',
            dataType: 'json',
            data: { name },
        }).then((res) => {
            const $line = $('#template_new_playlist > div').clone();
            $line.find('h3 span.main-title').html(name);
            $line.prependTo('#playlists');
            $line.data('playlist-id', res.id);
            $line.show();
        });
    }

    playlistEdit($button) {
        const $line = $button.parents('.netflix-line-row');
        const id = $line.data('playlist-id');
        location.href = resolveRoot(`playlist/${id}`);
    }

    playlistDelete($button) {
        const $line = $button.parents('.netflix-line-row');
        const id = $line.data('playlist-id');

        const transition = { transitionOut: 'fadeOut' };

        iziToast.error({
            timeout: 20000,
            close: false,
            overlay: true,
            toastOnce: true,
            zindex: 999,
            title: 'Delete playlist?',
            position: 'center',
            buttons: [
                ['<button>Yes, DELETE</button>', (instance, toast) => {
                    $.ajax({
                        url: resolveRoot(`ajax/playlist/${id}`),
                        method: 'DELETE',
                    }).then(() => {
                        $line.remove();
                    });

                    instance.hide(transition, toast, 'button');
                }],
                ['<button><b>Keep It</b></button>', (instance, toast) => {
                    instance.hide(transition, toast, 'button');
                }, true],
            ],
        });
    }

    initGex() {
        $('.gex-course').each($wrap(($gex) => {
            const group = $gex.data('group');
            if (!hasGroup(group)) $gex.show();
            const transition = { transitionOut: 'fadeOut' };

            const buttons = [
                ['<button>Hide</button>', (instance, toast) => {
                    this.toggleGex($gex, group);
                    instance.hide(transition, toast, 'button');
                }],
                ['<button><b>CANCEL</b></button>', (instance, toast) => {
                    instance.hide(transition, toast, 'button');
                }, true],
            ];

            $gex.find('.gex-hide').on('click', () => {
                iziToast.warning({
                    buttons,
                    title: 'You can restore this from the grammar course page',
                    timeout: 20000,
                    overlay: true,
                    position: 'center',
                });
            });
        }));
    }

    toggleGex($gex, group) {
        let catalog = 'expressions';
        if (group.includes('grammar')) catalog = 'grammar';

        $.getJSON(resolveRoot(`gex-course/toggle-gex/${catalog}`)).then((res) => {
            if (res.status !== 'ok') {
                console.error(res.message);
            } else {
                $gex.toggle();
            }
        }).fail((res) => {
            console.error(res);
        });
    }

    initScroll() {
        const $window = $(window);
        const $lane = $('.running-lane');
        const $header = $('#header');
        const color = $header.css('background-color').replace('rgb', 'rgba');

        $window.on('scroll', throttle(() => {
            const height = $lane.height() * 0.7;
            if (window.scrollY < height) {
                const alpha = window.scrollY / height;
                const newColor = color.replace(')', `, ${alpha})`);
                $header.css('background-color', newColor);
                $header.removeClass('normal');
            } else {
                $header.css('background-color', color);
                $header.addClass('normal');
            }

            const height2 = $lane.height() * 0.5;
            if (window.scrollY < height2) {
                $header.removeClass('normal');
            } else {
                $header.addClass('normal');
            }
        }, 100)).trigger('scroll');
    }

}, ['landing', 'playlists']);

/******   Splash slide show controller ****************/
if (!localStorage.splashIdx) {
    localStorage.splashIdx = 0;
}
function cycleFeature() {
    let splashes = document.getElementsByClassName('slide');

    for (let i = 0; i < splashes.length; i++) {
        splashes[i].style.display = 'none';
    }

    if (splashes.length > 0) {
        if (localStorage.splashIdx >= splashes.length) { localStorage.splashIdx = 0; }
        splashes[localStorage.splashIdx].style.display = 'block';

        let menuSpan = document.getElementById('top-menu');
        let menuIcon = document.getElementById('nav_button')
                                                              .getElementsByTagName('div')[0]
                                                                  .getElementsByTagName('div');

        const menuColor = document.getElementsByClassName('menu-placeholder')[localStorage.splashIdx].style.color;
        menuSpan.style.color = menuColor;
        for (let div of menuIcon) {
            div.style.backgroundColor = menuColor;
        }

        incSplashIdx();
    }

    if (splashes.length > 1) { //No need to cycle if just 1
        setTimeout(cycleFeature, 15000);
    }

}

function incSplashIdx() {
    localStorage.splashIdx = Number(localStorage.splashIdx) + 1;
}

cycleFeature();
/******  End  Splash slide show controller ****************/
